import { Pipe, PipeTransform } from '@angular/core';
import { COMMON_DATE_FORMATS } from '@sharedModels/enums';
import   moment                from 'moment';

export interface TransformParameters  {
  usedDelimiter     ?: DELIMITER,
  requiredDelimiter ?: DELIMITER,
  isProductType     ?: boolean
  convertToCurrency ?: boolean
  isTimeStamp       ?: boolean
  displayTime       ?: boolean
}

export enum DELIMITER {
  SPACE      = ' ',
  HYPHEN     = '-',
  UNDERSCORE = '_',
  COMMA      = ',',
}

@Pipe({
  name: 'transformText'
})

export class TransformTextPipe implements PipeTransform {

  transform(value: string|number, additionalParams ?: TransformParameters): any {
    if(!additionalParams || !value) {
      switch(value) {
        case ""  : return ""
        case 0   : return 0
        default  : return value || '--'
      } 
    }

    let resultantText = value

    if(additionalParams.isProductType) {
      switch(resultantText) {
        case 'LOYALTY' : return 'SWASTH'
        case 'INSTITUTION' : return 'SWASTH CORPORATE'
        default : return resultantText || '--'
      }
    }

    if(additionalParams.usedDelimiter) {
      const data = resultantText.toString().split(additionalParams.usedDelimiter)
      if(!additionalParams.requiredDelimiter) additionalParams.requiredDelimiter = DELIMITER.SPACE
      resultantText = data.join(additionalParams.requiredDelimiter)
    }

    if(additionalParams.convertToCurrency) {
      resultantText = value.toLocaleString('en-IN', {
        style                 : 'currency',
        currency              : 'INR',
        minimumFractionDigits : 0
      })
    }
    
    if(additionalParams.isTimeStamp) {      
      resultantText = additionalParams.displayTime === false ? 
                        moment(resultantText).format(COMMON_DATE_FORMATS.DD_MM_YYYY) : 
                        moment(resultantText).format(COMMON_DATE_FORMATS.YYYY_MM_DD_hh_mm_ss_A)
     
    }
    
    return resultantText
  }
}
